/**
 * @desc WMS修改出库计划单状态
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OutPlanUpdateStatusRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/updateOutPlanStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
